<script setup lang="ts">
const props = defineProps({
  /** Edge length in px — 13 on a group's trigger row, 11 on a result row. */
  size: {
    type: Number,
    default: 13,
  },
  /** Stroke colour: the accent on a trigger row, ink or faint on a result row. */
  color: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <!-- The bolt that marks an action trigger (Playbooks mock). Its own component
       so the group's trigger row and a result row that fired actions draw the
       same glyph rather than two copies of the path. -->
  <svg
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
    fill="none"
    :stroke="props.color"
    stroke-width="1.4"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M9 1.5 4 8.5h3l-.5 6 5-7h-3z" />
  </svg>
</template>
